export const normalizeMenuPath = (value?: string | null) => {
    const path = (value || '').trim().toLowerCase().replace(/\/+$/, '');
    return path ? (path.startsWith('/') ? path : `/${path}`) : '';
};

export const normalizeGrantedMenu = (menu: any) => {
    let code = String(menu?.Code ?? menu?.code ?? '').trim().toLowerCase();
    let path = normalizeMenuPath(menu?.Path ?? menu?.path);
    // Preserve the existing assignment when replacing the retired statistics entry.
    // The new learner statistics entry has its own permission and receives no implicit grant.
    if (code === 'bskt_thongke_dukien' || path === '/thong-ke-danh-sach-du-kien-hoc-bskt') {
        code = 'bskt_thongke_thisinh';
        path = '/thong-ke-thi-sinh-bskt';
    }
    return {code, path, active: menu?.IsActive ?? menu?.isActive ?? true};
};

export const canAccessMenu = (menus: ReturnType<typeof normalizeGrantedMenu>[], permission?: string, path?: string | null) => {
    const code=(permission || '').trim().toLowerCase(), target=normalizeMenuPath(path);
    const active=menus.filter(menu=>menu.active !== false);
    const dashboard=active.some(menu=>menu.code==='bskt_dashboard'||menu.path==='/dashboard');
    const statisticsCodes=['bskt_thongke_thisinh','bskt_thongke_hocvien'];
    const statisticsPaths=['/thong-ke-thi-sinh-bskt','/thong-ke-hoc-vien-bskt'];
    if(code==='bskt_dashboard'||target==='/dashboard')return dashboard || active.some(menu=>statisticsCodes.includes(menu.code)||statisticsPaths.includes(menu.path));
    if(dashboard && (statisticsCodes.includes(code)||statisticsPaths.includes(target)))return true;
    return active.some(menu=>(!!code&&menu.code===code)||(!!target&&menu.path===target));
};
